import { createApp } from 'vue'
import App from './App.vue'
import Homepage from '@/pages/HomePage'
import NewsPage from '@/pages/NewsPage'
import OrderManage from '@/pages/OrderManage'
import OrderCreate from '@/pages/OrderCreate'
import OrderEdit from '@/pages/OrderEdit'
import GeoPage from '@/pages/GeoPage'
import DocumentPage from '@/pages/DocumentPage'
import ContactPage from '@/pages/ContactPage'
import NotFound from '@/pages/NotFound'
import Cookie from '@/pages/Cookie';
import { createRouter, createWebHistory } from 'vue-router'
import '@/assets/css/main.css'

// 2. Define some routes
// Each route should map to a component.
// We'll talk about nested routes later.
const routes = [
  {
    path: "/",
    name: "home",
    component: Homepage,
  }, {
    path: "/cookie",
    name: "cookie",
    component: Cookie,
  },
  {
    path: "/news/:id",
    name: "news",
    component: NewsPage,
  },
  {
    path: "/manage",
    name: "manage",
    component: OrderManage,
  },
  {
    path: "/order",
    name: "order-create",
    component: OrderCreate,
  },
  {
    path: "/order/:id",
    name: "order-edit",
    component: OrderEdit,
  },
  {
    path: "/geo",
    name: "geo",
    component: GeoPage,
  },
  {
    path: "/documents",
    name: "documents",
    component: DocumentPage,
  },
  {
    path: "/contacts",
    name: "contacts",
    component: ContactPage,
  },
  // will match everything and put it under `$route.params.pathMatch`
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
];

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = createRouter({
  // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
  history: createWebHistory(),
  routes, // short for `routes: routes`
})

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import {
    faMapLocationDot,
    faLocationDot,
    faList,
    faFileLines,
    faFilePdf,
    faCalendarDays,
    faSearchLocation,
    faCalculator,
    faBars,
    faX
} from '@fortawesome/free-solid-svg-icons'
import {
    faTelegramPlane,
} from '@fortawesome/free-brands-svg-icons'

/* add icons to the library */
library.add(faMapLocationDot, faLocationDot, faTelegramPlane, faList, faFileLines, faFilePdf, faCalendarDays, faSearchLocation, faCalculator, faBars, faX)

createApp(App)
    .use(router)
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount('#app')

